const breakPoint = pcsp.breakpoint;
const isPc = () => $(window).width() > breakPoint; // 関数にして呼び出すたびに幅を判定

//============================================================
//	gHeader内にある「#」をクリックしたときの挙動
//============================================================
$('.gHeader a[href^="#"]').on('click', function() {
	$('.gHeader_navBtn').trigger('click'); // .gHeader_navBtnクリック時と同じ挙動
});

//============================================================
//	下層メニューの表示処理
//============================================================

//	PC（hover）
//------------------------------------------------------------
$(".gNav_item-hasDown").hover(function(){
	if (isPc()) {
		$(this).toggleClass("gNav_item-isActive");
		$(this).find('.gDown').toggleClass("gDown-isActive");
	}
});

//	SP（アコーディオン）
//------------------------------------------------------------
// メニューブロックで開閉
$(".gNav_itemHead").on('click', function(){
	if (!isPc()) {
		$(this).toggleClass("gNav_itemHead-isActive");
		$(this).closest(".gNav_item-hasDown").find(".gDown").slideToggle();
	}
});

// トグルボタンで開閉
// $(".gNav_itemToggle").on('click', function(){
// 	if (!isPc()) {
// 		$(this).toggleClass("gNav_itemToggle-isActive");
// 		$(this).closest(".gNav_item-hasDown").find(".gDown").slideToggle();
// 	}
// });

//============================================================
//	gHeader_navBtnの開閉
//============================================================
$('.gHeader_navBtn').on('click', function(){
	if (!isPc()) {
		toggle();
	}
});

const open = function() {
	$('.gHeader_navBtn').addClass('gHeader_navBtn-isActive');
	$('.gNav').addClass('gNav-isActive');
}
const close = function() {
	$('.gHeader_navBtn').removeClass('gHeader_navBtn-isActive');
	$('.gNav').removeClass('gNav-isActive');
}
const toggle = function(){
	$('.gHeader_navBtn').hasClass('gHeader_navBtn-isActive') ? close() : open();
}
